/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable, EventEmitter } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class LoaderService {
  public requestCountValue!: number;
  public loaderVisibility!: boolean;
  public isLoaderVisible: Observable<any>;
  public loaderVisibilityChange: Subject<any>;
  public isDisplayCancelVisible: Observable<any>;
  public displayCancelBtn: Subject<any>;
  public isPageLoad = false;

  constructor() {
    this.loaderVisibilityChange = new Subject<boolean>();
    this.isLoaderVisible = this.loaderVisibilityChange.asObservable();
    this.displayCancelBtn = new Subject<boolean>();
    this.isDisplayCancelVisible = this.displayCancelBtn.asObservable();
  }

  public showLoader() {
    this.loaderVisibility = true;
    this.loaderVisibilityChange.next(this.loaderVisibility);
  }

  public hideLoader() {
    this.loaderVisibility = false;
    this.loaderVisibilityChange.next(this.loaderVisibility);
  }

  public displayCancelOption(val: any) {
    this.displayCancelBtn.next(val);
  }

  public setRequestCount(value: any) {
    this.requestCountValue = value;
  }

  public getRequestCount() {
    return this.requestCountValue;
  }

  public setPageLoad(val: any) {
    this.isPageLoad = val;
  }

  public getPageLoad() {
    return this.isPageLoad;
  }

}
